import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import psllogo from "../assets/psllogo.png";
import ExploreIcon from '@mui/icons-material/Explore';
import dashboard_options from "../data/dashboardOptions";
import { Grid, useTheme, Button, IconButton, Tooltip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";
import { addDashboard, getDashboard } from "../redux/slices/dashboardSlice";
import JoyRideComponent from "../components/JoyRideComponent";
import Dashboard from "../components/Dashboard";
import Requests from "../components/Requests";
import Models from "../components/Models";
import Users from "../components/Users";
import Provision from "../components/Provision";
import apiCall from "../utils/apiCall";
import { GET_PROVISION_DETAILS, GET_USER_TYPE } from "../endpoint";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { addError } from "../redux/slices/errorSlice";
import ReactJoyride, { STATUS, Step } from "react-joyride";
import { adminSteps } from "../components/AdminTourSteps";
import { brandingSettings } from "../branding";

const drawerWidth = 200;

export default function Admin() {
  const dispatch = useAppDispatch();
  const [isJoyRideRunning, setIsoyRideRunning] = React.useState(false)
  const [joyRideSteps, setJoyRideSteps] = React.useState<Step[]>([])
  const dashboard_state = useAppSelector(getDashboard);
  const [provisionstep, setProvisonStep] = React.useState<Step[]>([])
  const [noadmin, setNoadmin] = React.useState(false);
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = accounts[0];
  const startJoyRide = React.useCallback(() => {
    setIsoyRideRunning(true)
  }, [])
  React.useEffect(() => {
    let steps: Step[] = adminSteps
    if (dashboard_state === "Access Control") {
      steps = steps.concat(provisionstep)
    }
    setJoyRideSteps(steps);
  }, [dashboard_state, provisionstep])
  const theme = useTheme();
  React.useEffect(() => {
    const fetch_pdfs = () => {
      apiCall("POST", GET_USER_TYPE, {
        user_email: account.username,
      })
        .then((res) => {
          if (res.result === "none") {
            navigate("/noaccess");
          } else if (res.result === "user") {
            setNoadmin(true);
          }
        })
        .catch((err) => {
          navigate("/");
          dispatch(addError("Failed to load the user type.Please try again"))
        });
    };
    fetch_pdfs();
  }, []);


  return (
    <>
      <JoyRideComponent steps={joyRideSteps} isJoyRideRunning={isJoyRideRunning} onFinish={() => setIsoyRideRunning(false)} />
      {noadmin ? (
        <Grid
          container
          sx={{
            mt: 5,
            textAlign: "center",
            ml: 10,
          }}
        >
          <Typography>Sorry, you donot have access</Typography>
        </Grid>
      ) : (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: theme.palette.mode === 'dark' ? brandingSettings.headercolorDark : brandingSettings.headercolor }}
          >
            <Toolbar>
              <img src={psllogo} alt="Persistent logo" width={30} />
              <Typography
                variant="h6"
                noWrap
                sx={{
                  fontFamily: "Poppins",
                  fontWeight: 900,
                  color: theme.palette.mode === 'dark' ? brandingSettings.textcolorSecondaryDark : 'inherit',

                  textDecoration: "none",
                  padding: 2,
                  fontSize: "15px",
                  pr: 1,
                  flex: 1,
                }}
              >
                Playground - Admin Dashboard
              </Typography>
              <Tooltip title="Start virtual tour">
                <IconButton onClick={startJoyRide} sx={{ marginRight: 3 }}>
                  <ExploreIcon style={{ color: 'gray' }} />
                </IconButton>
              </Tooltip>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: drawerWidth,
                boxSizing: "border-box",
              },
            }}
          >
            <Toolbar />
            <Box
              sx={{
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {dashboard_options.map((option) => (
                <>
                  <Grid
                    id={option.id}
                    container
                    sx={{
                      p: 2,
                      borderRight:
                        dashboard_state === option.name
                          ? `5px solid ${theme?.palette?.primary?.main}`
                          : "5px solid" + theme?.palette?.mode === 'dark' ? '#ff000' : '#fff',
                      cursor: "pointer",
                    }}
                    key={option.name}
                    alignItems="center"
                    // data-testid={option?.testid}
                    onClick={() => dispatch(addDashboard(option.name))}
                  >
                    {option.icon(
                      dashboard_state === option.name ? " primary" : "secondary"
                    )}
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight:
                          dashboard_state === option.name ? "bolder" : "normal",
                      }}
                      color={
                        dashboard_state === option.name
                          ? theme.palette.primary.main
                          : theme.palette.mode === 'dark' ? '#f1f1f1' : "secondary"
                      }
                    >
                      {option.name}
                    </Typography>
                  </Grid>
                  <Divider
                    sx={{
                      width: "80%",
                      background:
                        dashboard_state === option.name ? theme?.palette?.primary?.main : "#231e28",
                    }}
                  />
                </>
              ))}
            </Box>
          </Drawer>
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Toolbar />
            {dashboard_state === "Dashboard" ? (
              <Dashboard />
            ) : dashboard_state === "Requests" ? (
              <Requests />
            ) : dashboard_state === "Models" ? (
              <Models />
            ) : dashboard_state === "Users" ? (
              <Users />
            ) : (
              <Provision setProvisionSteps={setProvisonStep} />
            )}
          </Box>
        </Box>
      )}
    </>
  );
}
